import 'babel-polyfill'
import './setup.TARGET_APP'

import React from 'react'
import ReactDOM from 'react-dom'
import { unregister } from './utils/registerServiceWorker'
import { initAuth } from './utils/auth'
import App from '@/App'
import context from '@/context'

const render = Component => {
  ReactDOM.render(<Component />, document.getElementById('root'))
}

render(App)
unregister()
initAuth()

// Allow Hot Module Replacement
if (module.hot) {
  module.hot.accept('./setup.TARGET_APP', () => {
    render(App)
    context.replaceReducers && context.replaceReducers()
  })
}



// WEBPACK FOOTER //
// ./src/index.js